import styled from 'styled-components';
import { SkeletonBase } from '../../UIelements/Skeleton/styles';

export const SkeletonContainer = styled.div`
  margin: 15px 20px 10px 20px;
  box-shadow: 0 0 0.7em ${props => props.theme.colors.boxShadow};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const InfoBarLayout = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
  margin: 0 20px;
`;

export const InfoCardSkeleton = styled(SkeletonBase)`
  height: 80px;
  flex: 1;
  min-width: 160px;
`;

export const GraphAndControlsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 80%;
  margin: 0 auto;
`;

export const ControlsContainer = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
`;

export const RadioSkeleton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;